import { useQuery } from 'react-query';
import { queryKeys } from '../constants';
import api from 'api';
import { AppError } from 'utils/AppError';

const useFetchUserDetails = (userId?: string | null) => {
  const query = useQuery({
    queryKey: [queryKeys.FETCH_USER_DETAILS, userId],
    queryFn: () => api.userQueries.getUserbyId({ userId: userId! }),
    select: (data) => data?.payrollGetUser.data,
    onError: (error: AppError) => {},
  });

  const firstName = query.data && query.data.name ? query.data?.name.split(' ')[0] : null;

  return { ...query, firstName };
};

export default useFetchUserDetails;
